import React from 'react';
import { HiOutlinePencilAlt } from 'react-icons/hi';
import { useNavigate } from 'react-router';
import intl from 'components/i18n/ReactIntlWrapper';

const ProviderRow = ({ id, name, className }) => {

    const navigate = useNavigate();

    const handleClickRow = () => {
        navigate('/provider/detail/' + id);
    };

    return (
        <>
            {
                name ?
                <tr className={className} style={{cursor: "default"}}>
                    <td>{name}</td>
                    <td className='text-center'>
                        <a className='td-icon mx-1' style={{cursor: "pointer"}} onClick={handleClickRow} title={intl.get('roleRow.editButton.title')}>
                            <HiOutlinePencilAlt/>
                        </a>
                    </td>
                </tr> :
                null
            }
        </>
    )
}

export default ProviderRow;
